module.exports = __webpack_public_path__ + "images/Revolve-32dad9.png";